import { IFilterSettings, TQueryFilter } from '../Types/FilterTypes';

/**
 * Converts IFilterSettings to query string format for backend
 * @param settings - Filter settings object
 * @returns Query string parameters object
 */
export const convertFilterSettingsToQuery = (settings: IFilterSettings): TQueryFilter => {
  let queryParams: TQueryFilter = {
    sortField: 'createdAt',
    sortDirection: 'DESC',
    page: 1,
    take: 50,
  };

  // Add filter fields as filter_* parameters
  if (settings.filter && settings.filter.length > 0) {
    settings.filter.forEach(filter => {
      if (filter.field && filter.value !== undefined) {
        queryParams[`filter_${filter.field}`] = filter.value;
      }
    });
  }

  // Add pagination
  if (settings.pagination) {
    queryParams = { ...queryParams, ...settings.pagination };
  }

  // Add sorting
  if (settings.sorting?.field || settings.sorting?.order) {
    if (settings.sorting.field) {
      queryParams.sortField = settings.sorting.field;
    }
    if (settings.sorting.order) {
      queryParams.sortDirection = settings.sorting.order;
    }
  }

  return queryParams;
};

/**
 * Converts TQueryFilter object to URL query string
 * @param params - Query parameters object
 * @returns URL-encoded query string (without leading ?)
 */
export const queryParamsToString = (params: TQueryFilter): string => {
  const searchParams = new URLSearchParams();
  
  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });
  
  return searchParams.toString();
};
